// extracted by mini-css-extract-plugin
export default {"container":"SummayOrderSection_container__0unVS","box":"SummayOrderSection_box__6CDLs"};